import Vue from 'vue'
import md5 from 'js-md5';
import {MessageBox} from 'element-ui'
import store from '../store'
import router from '@/router/index'

// 时间戳转时间 now：当前时间  type:1 年月日时分秒  else
function ZHDate(now, type) {
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let date = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type == 1) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type == 2) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type == 3) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type == 4) {
    return year
  } else {
    return year + "-" + getzf(month) + "-" + getzf(date)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}


function checkTel(tel) { //验证手机号
  if (!(/^1[3456789]\d{9}$/.test(tel))) {
    return true
  } else {
    return false
  }
}

function checkEmail(tel) { //验证手邮箱
  if ((/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(tel))) {
    return true
  } else {
    return false
  }
}

function sginOut() {
  MessageBox.confirm(
    '您确定要退出吗？',
    '温馨提示', {
      confirmButtonText: '确定',
      type: 'warning',

      closeOnClickModal: false,
      closeOnPressEscape: false,
    }
  ).then(() => {
    store.dispatch('LogOut').then(() => {
      router.push('/Login')
      // location.reload() // 为了重新实例化vue-router对象 避免bug
    })
  })
}


function browserRedirect() {   //  1 手机 2 pc
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    return 2
  } else {
    return 1
  }
}


const tools = {
  ZHDate,
  checkTel,
  checkEmail,
  sginOut,
  browserRedirect
}

Vue.prototype.$md5 = md5;
Vue.prototype.$tools = tools;
